import { Typography, Checkbox, Box } from '@mui/material'
import { FormControlLabel } from 'Features/Project/WorkcentreModal/FormControlLabel/FormControlLabel.view'
import {
  AccordionDetailsContent,
  AccordionDetailsRoot,
  StyledCheckbox,
} from 'Features/Project/WorkcentreModal/AccordionDetails/AccordionDetails.styles'

export const AccordionDetails = ({
  sourceSiteData,
  handleCheckboxChange,
  readOnly,
}: any) => {
  return (
    <AccordionDetailsRoot id={sourceSiteData.siteLabel}>
      {sourceSiteData.siteWorkcentres.map((worcentre: any) =>
        readOnly ? (
          worcentre.isSelected ? (
            <AccordionDetailsContent key={worcentre.key}>
              <Typography>{worcentre.code}</Typography>
            </AccordionDetailsContent>
          ) : null
        ) : (
          <AccordionDetailsContent>
            <FormControlLabel
              label={worcentre.code}
              control={
                <StyledCheckbox
                  //disabled={worcentre.productCount === 0}
                  color="primary"
                  checked={worcentre.isSelected}
                  onChange={(event) =>
                    handleCheckboxChange(
                      event,
                      sourceSiteData.siteLabel,
                      worcentre.code
                    )
                  }
                />
              }
            />
          </AccordionDetailsContent>
        )
      )}
    </AccordionDetailsRoot>
  )
}
